// extracted by mini-css-extract-plugin
export default {"main":"style_main__7lrHq","subTitle":"style_subTitle__RsXvD"};